import { Component, ElementRef, ViewChild, ComponentFactoryResolver, ViewContainerRef, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { AspOrderListService } from '../../auto-spare-parts/asp-order-list/asp-order-list.service';
import { AspOrderDetailsComponent } from '../asp-order-details/asp-order-details.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { AspLoadingComponent } from '../asp-loading/asp-loading.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AspLoadingService } from "../asp-loading/asp-loading.service";
import { ToastrService } from 'ngx-toastr';

interface FilterOption {
  label: string;
  value: string;
  checked: boolean;
  children?: FilterOption[];
}

interface Filters {
  orderStatus: FilterOption[];
  orderTime: FilterOption[];
}

@Component({
  selector: 'app-asp-order-list',
  templateUrl: './asp-order-list.component.html',
  styleUrls: ['./asp-order-list.component.scss']
})

export class AspOrderListComponent implements OnInit, AfterViewInit {
  emptyList:any = 'assets/images/no-cart.png';
  @ViewChild('filterSection', { static: false }) filterSection!: ElementRef;
  @ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
  @ViewChild('dynamicContainers', { read: ViewContainerRef }) containers!: ViewContainerRef;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  searchTerm: string = '';
  showClearIcon: boolean = false;
  pageIndex : number = 0;
  pageSize : number = 150;
  totalPages : number = 0;
  length : number = 0;
  

  filters: Filters = {
    orderStatus: [
      { label: 'Created', value: 'Created', checked: false },
      { label: 'Confirmed', value: 'Confirmed', checked: false },
      { label: 'Packed', value: 'Packed', checked: false },
      { label: 'On The Way', value: 'On the way', checked: false },
      { label: 'Delivered', value: 'Delivered', checked: false }
    ],
    orderTime: [
      { label: 'Today', value: 'TODAY', checked: false },
      { label: 'Yesterday', value: 'YESTERDAY', checked: false },
      { label: 'Last 7 days', value: 'LAST_7_DAYS', checked: false },
      { label: 'Last 30 days', value: 'LAST_30_DAYS', checked: false },
      { label: 'Last Month', value: 'LAST_MONTH', checked: false },
      { label: 'Any Time', value: 'ANY_TIME', checked: false }
    ]
  };
  deliveries = [ ];
  
  loading: boolean = false;
  orderList: any[] = [];
  filteredOrderList: any[] = [];
  // searchTerm: string = '';
  selectedOrderStatus: string = '';
  selectedOrderTime: string = '';
  selectedOrder: any = null;
  isSidebarVisible: boolean = false;
  orderDeliveryTimeFormatted: string;
  isMobile: boolean;
  isSidebarOpen: boolean = false;
  list: any;
  hideScrollText: boolean= false;
  names: any;
  packedNames: any;
  orderKey: any;
  wcSelectedOrderStatus: string = '';

  constructor(
    private aspOrderListService: AspOrderListService,
    private resolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private aspLoadingService: AspLoadingService,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); }

  // ngOnInit(): void {
  //   localStorage.removeItem('selectedRequestStatus');
  //   localStorage.removeItem('selectedRequestTime');
  //   this.getList();
  // }
  ngOnInit(): void {
    localStorage.removeItem('selectedRequestStatus');
    localStorage.removeItem('selectedRequestTime');

    // ✅ Listen for Warranty CTA filter
    this.route.queryParams.subscribe(params => {
      if (params['wcStatus']) {
        this.wcSelectedOrderStatus = params['wcStatus'];
      }
    });

    this.getList();
  }

  handlePageEvent(event: any) {
    
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.getList();
  }

  // ngAfterViewInit(): void {
  //   this.loadorderdetails();
  // }



  loadorderdetails(orderKey) {
    
    this.orderKey = orderKey;
    const factory = this.resolver.resolveComponentFactory(AspOrderDetailsComponent);
    const componentRef = this.container.createComponent(factory);

    // Access the instance and call the method
    const componentBInstance = componentRef.instance as AspOrderDetailsComponent;
    componentBInstance.closeSidebar(true);
    componentBInstance.getOrderDetails(orderKey);

  }
ngAfterViewInit() {
    this.loadingMsg();
    this.cdr.detectChanges();
  }

  loadingMsg() {
    
    const factory = this.resolver.resolveComponentFactory(AspLoadingComponent);
    
   

    if (this.containers) {
      const componentRef = this.containers.createComponent(factory);
      

      const componentBInstance = componentRef.instance as AspLoadingComponent;
      componentBInstance.getLoadingMsg();
    } else {
      console.error('containers is undefined');
    }
  }
  
  sidecontainer() {
    this.isSidebarOpen = !this.isSidebarOpen; // Toggle the sidebar open/close state
  }

  toggleSelection(orderTimeKey: keyof Filters, option: FilterOption) {
    if (orderTimeKey === 'orderStatus') {
      this.filters.orderStatus.forEach(status => {
        status.checked = (status.value === option.value);
      });
      this.selectedOrderStatus = option.value;
    } else if (orderTimeKey === 'orderTime') {
      this.filters.orderTime.forEach(time => {
        time.checked = (time.value === option.value);
        if (time.children) {
          time.children.forEach(child => {
            child.checked = (child.value === option.value);
          });
        }
      });
      this.selectedOrderTime = option.value;
    }
    this.filterOrders();
  }

  clearFilters() {
    this.selectedOrderStatus = '';
    this.selectedOrderTime = '';
    const clearOptions = (options: FilterOption[]) => {
      options.forEach(option => {
        option.checked = false;
        if (option.children) {
          clearOptions(option.children);
        }
      });
    };
  
    (Object.keys(this.filters) as (keyof Filters)[]).forEach(orderTimeKey => {
      clearOptions(this.filters[orderTimeKey]);
    });
    this.filterOrders();
  }
  
  hasAppliedFilters(): boolean {
    return this.selectedOrderStatus !== '' || this.selectedOrderTime !== '';
    
  }

  getAppliedFilters(): { orderTime: keyof Filters, option: FilterOption }[] {
    const appliedFilters: { orderTime: keyof Filters, option: FilterOption }[] = [];

    const addFilter = (orderTimeKey: keyof Filters, option: FilterOption) => {
      if (option.checked) {
        appliedFilters.push({ orderTime: orderTimeKey, option });
      }
    };

    (Object.keys(this.filters) as (keyof Filters)[]).forEach(orderTimeKey => {
      this.filters[orderTimeKey].forEach(option => {
        addFilter(orderTimeKey, option);
        if (option.children) {
          option.children.forEach(child => {
            addFilter(orderTimeKey, child);
          });
        }
      });
    });

    return appliedFilters;
  }

  removeFilter(orderTimeKey: keyof Filters, option: FilterOption) {
    option.checked = false;
    if (orderTimeKey === 'orderStatus') {
      this.selectedOrderStatus = '';
    } else if (orderTimeKey === 'orderTime') {
      this.selectedOrderTime = '';
    }
    this.filterOrders();
  }

  getList() {
    this.aspLoadingService.show(); 
    let spareUserKey = localStorage.getItem('spareUserKey');
    let garageKey = localStorage.getItem('garageKey');
    this.aspOrderListService.orderList(spareUserKey, garageKey,this.pageIndex , this.pageSize, this.isOn, this.searchTerm).subscribe(
      result => {
        // console.log("order-list-response",result)
        let res = JSON.parse(JSON.stringify(result)); 
        
  
          this.aspLoadingService.hide(); 
        if(res['code'] === 200){   
          
        this.length = res.data.orders.totalItems;
        this.totalPages = res.data.orders.totalPage;
        this.pageIndex = res.data.orders.currentPage;       
          // console.log("res.data.orders.data------",res.data.orders.data)
         res.data.orders.data.forEach(order => {
           order.orderCurrentStatus = order.orderCurrentStatus
          ? order.orderCurrentStatus.toLowerCase()
          : '';

            order.status = Number(order.status);
            // Add formatted delivery time
            order.titleName = this.formatOrderDeliveryTime(order.orderConfirmTime, order.orderDeliveryTime);

            // Get all order items
            const orderItems = order.orderItems;


            // Flatten ALL packed items from all packageDetails
            const packedItems = order.packageDetails.flatMap(pkg => pkg.items);

            // Find which orderItems are NOT packed (compare by partName)
            // order.notPackedItems = orderItems.filter(orderItem =>
            //   !packedItems.some(packedItem => packedItem.partNumber === orderItem.partNumber)
            // );
            order.notPackedItems = orderItems.filter(orderItem =>
            !packedItems.some(packedItem =>  packedItem.partNumber?.toLowerCase() === orderItem.partNumber?.toLowerCase() )
            );

            // console.log("order.notPackedItems", order.notPackedItems);

            // Format delivery time for each package
            order.packageDetails.forEach(pkg => {
              pkg.time = this.formatOrderDeliveryTime(order.orderConfirmTime, pkg.deliveryTime);
            });

            // ✅ If there are any notPackedItems, add them as a new package block
          
          });


          this.orderList = res.data.orders.data;

          this.filteredOrderList = res.data.orders.data;
          if (this.wcSelectedOrderStatus) {
            this.selectedOrderStatus = this.wcSelectedOrderStatus;
            this.filterOrders();
          }

          // console.log(" this.filteredOrderList", this.filteredOrderList);
        } else {
          this.filteredOrderList=[]
          this.orderList=[]
          this.aspLoadingService.hide(); 
          this.toastr.error(res['data']['description'], 'Error');
        }
        
      }
    );
  }
 

  // filterOrders() { 
  //   this.filteredOrderList = this.orderList.filter(order => {
  //      let statusToCheck: any;
  // if (order.packageDetails && order.packageDetails.length >= 1) {
  //   const rawStatus = order.packageDetails[0].shipmentStatus;
  //   statusToCheck = rawStatus
  //     ? rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).toLowerCase()
  //     : '';
  // } else {
  //   // Fallback to order.status
  //   const rawStatus = order.orderCurrentStatus;
  //    statusToCheck = rawStatus
  //     ? rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).toLowerCase()
  //     : '';
  //     //  console.log("rawStatus", rawStatus);
  //     //  console.log("statusToCheck", statusToCheck)
  // }
  // const statusMatch = this.selectedOrderStatus
  //   ? statusToCheck?.toString() === this.selectedOrderStatus
  //   : true;
  //     // const statusMatch = this.selectedOrderStatus ? order.status.toString() === this.selectedOrderStatus : true;
  //     const timeMatch = this.selectedOrderTime ? this.filterByTime(order.createdAt, this.selectedOrderTime) : true;
  //     const searchTerm = this.searchTerm.trim().toLowerCase();
  //     const searchMatch = this.searchTerm.trim() ? order.orderId.toString().toLowerCase().includes(this.searchTerm.trim().toLowerCase()) : true;
  //     console.log("---------searchMatch",searchMatch)
  //     const searchOrderNumber = this.searchTerm.trim() ? order.orderNumber.toString().toLowerCase().includes(this.searchTerm.trim().toLowerCase()) : true;
  //     const searchRegNo = this.searchTerm.trim()? order.registrationNumber?.toString().toLowerCase().includes(this.searchTerm.trim().toLowerCase()) : true;
  //     const requestId = this.searchTerm.trim()? order.requestId?.toString().toLowerCase().includes(this.searchTerm.trim().toLowerCase()) : true;
  //     const make = this.searchTerm.trim()? order.make?.toString().toLowerCase().includes(this.searchTerm.trim().toLowerCase()) : true;
  //     const model = this.searchTerm.trim()? order.model?.toString().toLowerCase().includes(this.searchTerm.trim().toLowerCase()) : true;
  //     const fuelType = this.searchTerm.trim()? order.fuelType?.toString().toLowerCase().includes(this.searchTerm.trim().toLowerCase()) : true;

  //     return statusMatch && timeMatch && (searchMatch || searchRegNo ||requestId || make || model || fuelType || searchOrderNumber || searchTerm) ;
  //   });
  
  // }
  filterOrders() { 
    this.hideScrollText = true
  this.filteredOrderList = this.orderList.filter(order => {
    let statusToCheck: any;

    if (order.packageDetails && order.packageDetails.length >= 1) {
      const rawStatus = order.packageDetails[0].shipmentStatus;
      statusToCheck = rawStatus
        ? rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).toLowerCase()
        : '';
    } else {
      // Fallback to order.status
      const rawStatus = order.orderCurrentStatus;
      statusToCheck = rawStatus
        ? rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).toLowerCase()
        : '';
    }

    const statusMatch = this.selectedOrderStatus
      ? statusToCheck?.toString() === this.selectedOrderStatus
      : true;

    const timeMatch = this.selectedOrderTime
      ? this.filterByTime(order.createdAt, this.selectedOrderTime)
      : true;

    // 🔥 Safe string conversion with fallback
    const searchTerm = this.searchTerm.trim().toLowerCase();

    const searchMatch = searchTerm
      ? order.orderId?.toString().toLowerCase().includes(searchTerm) || false
      : true;

    const searchOrderNumber = searchTerm
      ? order.orderNumber?.toString().toLowerCase().includes(searchTerm) || false
      : true;

    const searchRegNo = searchTerm
      ? order.registrationNumber?.toString().toLowerCase().includes(searchTerm) || false
      : true;

    const requestId = searchTerm
      ? order.requestId?.toString().toLowerCase().includes(searchTerm) || false
      : true;

    const make = searchTerm
      ? order.make?.toString().toLowerCase().includes(searchTerm) || false
      : true;

    const model = searchTerm
      ? order.model?.toString().toLowerCase().includes(searchTerm) || false
      : true;

    const fuelType = searchTerm
      ? order.fuelType?.toString().toLowerCase().includes(searchTerm) || false
      : true;

      const matchPartNumber = searchTerm
  ? order.orderItems?.some(item =>
      item.partNumber?.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : true;
   const matchPartName = searchTerm   
      ? order.orderItems?.some(item =>
          item.partName?.toLowerCase().includes(searchTerm)
        )
    : true;
  const matchPackageItems = searchTerm
    ? order.packageDetails?.some(pkg =>
        pkg.items?.some(item =>
          item.partNumber?.toLowerCase().includes(searchTerm)
        )
      )
  : true;
       const matchInvoiceNumber = searchTerm  
      ? order.orderInvoice?.some(inv =>
          inv.invoiceNumber?.toLowerCase().includes(searchTerm)
        )
      : true;
    return (
      statusMatch &&
      timeMatch &&
      (searchMatch || searchRegNo || requestId || make || model || fuelType || searchOrderNumber || matchPartNumber || matchPartName ||
        matchInvoiceNumber ||  matchPackageItems)
    );
  });
}

  
  filterByTime(orderTime: string, filter: string): boolean {
    const now = new Date();
    const orderDate = new Date(orderTime);

    switch (filter) {
      case 'TODAY':
        // Check if the orderDate is the same day as today
        return orderDate.toDateString() === now.toDateString();
        
      case 'YESTERDAY':
        // Check if the orderDate is the same day as yesterday
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        return orderDate.toDateString() === yesterday.toDateString();
        
      case 'LAST_7_DAYS':
        // Check if the orderDate is within the last 7 days
        const weekAgo = new Date(now);
        weekAgo.setDate(now.getDate() - 7);
        return orderDate >= weekAgo && orderDate <= now;
        
      case 'LAST_30_DAYS':
        // Check if the orderDate is within the last 30 days
        const monthAgo = new Date(now);
        monthAgo.setDate(now.getDate() - 30);
        return orderDate >= monthAgo && orderDate <= now;
        
      case 'LAST_MONTH':
        // Check if the orderDate is within the last month
        const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
        return orderDate >= lastMonthStart && orderDate <= lastMonthEnd;
        
      case 'ANY_TIME':
      default:
        return true;
    }
  }

  viewDetails(order: any) {
    this.selectedOrder = order;
    this.isSidebarVisible = true;
  }
  clearSearch() {
    this.searchTerm = '';
    this.showClearIcon = false;
    this.hideScrollText = false;
    this.filterOrders();
    
    this.hideScrollText = false
  }
  formatOrderDeliveryTime(confirmTime: string, deliveryTime: string) {
    try {
      const confirmDate = new Date(confirmTime.replace(" ", "T"));
      const deliveryDate = new Date(deliveryTime.replace(" ", "T"));

      if (isNaN(confirmDate.getTime()) || isNaN(deliveryDate.getTime())) {
        return '0 MINS';
        
      }

      const diffMs = deliveryDate.getTime() - confirmDate.getTime();
      const diffMins = Math.floor(diffMs / 60000);

      if (diffMins < 0) {
        return '0 MINS';
        
      }

      if (diffMins <= 180) {
        return `${diffMins} MINS`;
      } else {
        const hours = Math.floor(diffMins / 60);
        const MINS = diffMins % 60;
        return `${hours}H ${MINS}MINS`;
      }

    } catch (error) {
      return '0 MINS';
    }
}
// In your component's TypeScript file
getTotalAmount(): number {
  return this.list.grandTotal + (this.list.shippingCharges > 0 ? this.list.shippingCharges : 0);
}
 isOn = false;

toggle(event: any) {
    this.isOn = event.target.checked;
    // console.log('Toggle is:', this.isOn ? 'ON' : 'OFF');
    this.getList();
  }
  
  placeYourFirstOrder(){
    this.router.navigate(['/home']) 
  }
  
}


